import { api } from 'src/api';
import { types, getRoot } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
const getDefaultChargeOnDateAsync = createAsync(body => {
  return async function getDefaultChargeOnDate(options) {
    const resp = await api.AppfolioProperties.getDefaultChargeOnDate(body, options);
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      getRoot(this).allocations.setCurrentPropertyDefaultChargeOnDate(resp.response);
    }
    return resp;
  };
});
const AppfolioPropertiesApiStore = types.model('AppfolioPropertiesApiStore', {
  getDefaultChargeOnDateAsync
});
export const appfolioPropertiesApi = types.optional(AppfolioPropertiesApiStore, {});